module.exports = __webpack_public_path__ + "img/lock.ba709966.svg";